import Flex from 'components/Flex'
import {
  StyledCheckbox,
  StyledGroup,
} from 'components/UIComponents/FilterCheckBoxComp/style'
import React from 'react'

const FilterCheckBoxComp = ({
  value,
  options,
  onChange,
  valueParam = 'value',
  labelParam = 'label',
  onChangeCheck,
}) => {
  return (
    <StyledGroup value={value} onChange={onChange}>
      {options?.map((item, index) => (
        <Flex spaceBetween centerVertically key={index + 'filterCheckBox'}>
          <StyledCheckbox
            value={item[valueParam]}
            label={
              item[labelParam] == 'FACE_TO_FACE' ||
              item[labelParam] == 'ASSESMENT' ||
              item[labelParam] == 'GROUP' ||
              item[labelParam] == 'PENDING' ||
              item[labelParam] == 'RESCHEDULE_REQUESTED' ||
              item[labelParam] == 'SCHEDULED' ||
              item[labelParam] == 'SELECTED' ||
              item[labelParam] == 'HOLD' ||
              item[labelParam] == 'REJECTED' ||
              item[labelParam] == 'SHORTLISTED'
                ? item[labelParam]
                    ?.split('_')
                    ?.map(
                      word =>
                        word?.charAt(0)?.toUpperCase() +
                        word?.slice(1)?.toLowerCase()
                    )
                    ?.join(' ')
                : labelParam == 'tier'
                ?  item[labelParam]
                : item[labelParam]
            }
            onChange={onChangeCheck}
          />
        </Flex>
      ))}
    </StyledGroup>
  )
}

export default FilterCheckBoxComp
